module.exports = __webpack_public_path__ + "img/down-gz2.5d32ab59.jpg";